import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { Link, useNavigate} from 'react-router-dom';
import Confirmation from '../common/confimation.component';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [row, setCurrentRow] = useState(null);
  const [filteredData, setFilteredData] = useState([]); // filtered for display
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
   getSubCategories();
  }, []);
useEffect(() => {
  const filtered = categories.filter((item) => {
    const text = searchText.toLowerCase();
    return (
      item.category_name?.toLowerCase().includes(text) ||
      item.name?.toLowerCase().includes(text) ||
      item.price?.toString().includes(text) ||
      item.service_duration?.toLowerCase().includes(text)
     
    );
  });
  setFilteredData(filtered);
}, [searchText, categories]);
  const getSubCategories = () => {
        setLoading(true);

     DataService.getSubCategories()
          .then((response) => {
           const data = response.data
           console.log(data);
            setCategories(data);
            setLoading(false);

          })
          .catch((error) => {
            setLoading(false);
          });
  }

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      
    },
    {
      name: 'Category Name',
      selector: row => row.category_name,
      sortable: true,
     
    },
     {
      name: 'Sub Category Name',
      selector: row => row.name,
      sortable: true,
     
    },
    {
      name: 'Price',
      selector: row => '$'+row.price,
      sortable: true,
     
    },
    {
      name: 'Service Duration',
      selector: row => row.service_duration + 'm',
      sortable: true,
     
    },
   
    {
  name: 'Actions',
  cell: row => (
    <div className="d-flex gap-2 align-items-center">
      <FontAwesomeIcon
        icon={faEdit}
        className="text-primary"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        onClick={() => editData(row)}
      />
      <FontAwesomeIcon
        icon={faTrash}
        className="text-danger"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        onClick={() => deleteData(row)}
      />
    </div>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  width: '280px',
}
  ];
const navigate = useNavigate();
  
  const redirect = () => {
    navigate('/add-subcategory')
  }
 const deleteData = (row) => {
    setCurrentRow(row);
    setModalShow(true);
  };
 const editData = (data) => {
      navigate('/edit-subcategory', { state: { data } });
  }

  const updateStatus = () => {
    console.log("Cscsc")
    if (!row) return;

    setLoading(true);
    DataService.deleteSubCategory({ id: row.id })
      .then((response) => {
      toast.success('Sub Category deleted successfully.')
       getSubCategories();
        setModalShow(false);
      })
      .catch(() => {
        setLoading(false);
        setModalShow(false);
      });
  };

  return (
      <>
      <LoaderOverlay loading={loading} />
    <div >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Sub Categories</h4>
        <button className="btn btn-success" onClick={redirect}>Add Sub Category</button>
      </div>
 <input
        type="text"
        placeholder="Search"
        className="form-control mb-3 px-3"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
        <DataTable
          columns={columns}
        data={filteredData}
        pagination
        highlightOnHover
        striped
        responsive
        noHeader
      />
    </div>
      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={updateStatus}
        handleClose = {() => setModalShow(false)}
      />
    </>
  );
};

export default Categories;
